import React, {useContext, useRef} from "react";
import PhotoSwiperZoom from '@components/general/PhotoSwiperZoom.jsx';

const ReviewsPhotos = ({image_data}) => {

  const popup = useRef();

  const popupItems = image_data.map(({id, thumb_url, original_url})=>({
    src: original_url,
    originalSrc: thumb_url,
    mediaId: id,
    type: "image"
  }));

  const openPopup = (id) => (e) => {
    e.preventDefault();
    popup.current.open({
      initialSlideMediaId:id
    });
  }

  return (<div className={`ft_yotpo-review-photos`}>
    {image_data.map((image, index)=>{

      return (<a key={image.id} href={image.original_url} onClick={openPopup(image.id)} target="_blank">
          <img src={image.thumb_url} className="ft_yotpo-review-photo" />
          {index == 3 && image_data.length > 4 ? <div class="ft_yotpo-review-photo__overlay">+ {image_data.length - 4}</div> : null}
        </a>)
    }).slice(0,4)}
    <PhotoSwiperZoom ref={popup} items={popupItems} />
  </div>);

}

export default ReviewsPhotos;
